import React from "react";
import ScheduleClasses from "./Cancel.module.css";
import TableLoad from "Components/TableLoad/load";
import Moment from "react-moment";

import { useNavigate } from "react-router";

const Classes = ({
    classesData,
    Loading,
    rowSelect,
    handleCheckboxChange,
    handleSelectAll,
    selectedRows,
}) => {
    const Navigate = useNavigate();

    // PAGE NAVIGATION HANDLER TO DETAILS PAGE
    const classDetails = (event) => {
        if (!selectedRows) {
            const id = event?.currentTarget.getAttribute("id");
            Navigate(`/scheduledClasses/Details?scheduleID=${id}`);
        }
    };
    let tableHead = [
        "Class",
        "Start Date Time",
        "End Date",
        "Duration",
        "Course Details",
        "Cancel Reason",
        "Status",
    ];
    return (
        <>
            <h3>Classes</h3>

            {Loading ? (
                <TableLoad TableHead={tableHead} />
            ) : (
                <div className={ScheduleClasses["Table"]}>
                    <table>
                        <thead>
                            <tr>
                                {rowSelect && (
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={
                                                selectedRows &&
                                                selectedRows.length ===
                                                classesData.length
                                            }
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                )}
                                <th>Class</th>

                                <th>Start Date Time</th>
                                <th>End Time</th>
                                <th>Duration</th>
                                <th>Course Details</th>
                                <th>Lesson Plan</th>
                                <th>Cancel Reason</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {classesData?.length > 0 ? (
                                classesData?.map((item, index) => {
                                    return (
                                        <tr
                                            id={item.ScheduleClassID}
                                            onClick={classDetails}>
                                            {rowSelect && (
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            selectedRows &&
                                                            selectedRows.includes(
                                                                item.ScheduleClassID
                                                            )
                                                        }
                                                        onChange={() => {
                                                            handleCheckboxChange(
                                                                item.ScheduleClassID
                                                            );
                                                        }}
                                                    />
                                                </td>
                                            )}
                                            <td>{item.ClassLessonName}</td>

                                            <td>
                                                <Moment format="DD-MM-YYYY">
                                                    {
                                                        new Date(
                                                            item.Scheduled_StartDate
                                                        )
                                                    }
                                                </Moment>{" "}
                                                <br />
                                                {String(
                                                    item.Scheduled_StartTime
                                                )}
                                            </td>
                                            <td>
                                                {String(item.Scheduled_EndTime)}
                                            </td>
                                            <td> {item.ClassDuration} Min</td>
                                            <td>
                                                {item.CourseName} <br />
                                                <span
                                                    style={{
                                                        fontSize: "0.9rem",
                                                    }}>
                                                    {" "}
                                                    ({item.BatchSize})
                                                </span>
                                            </td>

                                            <td
                                                style={{
                                                    wordWrap: "break-word",
                                                    maxWidth: "200px",
                                                }}>
                                                {" "}
                                                {item?.LessonPlans_Class &&
                                                    item.LessonPlans_Class.join(
                                                        ","
                                                    )}
                                                {item?.PartiallyCompleted
                                                    ?.IsPartiallyCompleted ==
                                                    1 && (
                                                        <>
                                                            ,
                                                            {
                                                                item
                                                                    ?.PartiallyCompleted
                                                                    .LessonPlan
                                                            }
                                                            (
                                                            {
                                                                item
                                                                    ?.PartiallyCompleted
                                                                    .Slide
                                                            }
                                                            )
                                                        </>
                                                    )}
                                            </td>

                                            <td
                                                style={{
                                                    wordBreak: "break-word",
                                                    maxWidth: "3rem",
                                                }}>
                                                {item.CancelReason}
                                            </td>
                                            <td>
                                                {item.ClassStatus === 1 ? (
                                                    <span
                                                        className={
                                                            ScheduleClasses[
                                                            "active-stat"
                                                            ]
                                                        }>
                                                        Pending
                                                    </span>
                                                ) : item.ClassStatus === 2 ? (
                                                    <span
                                                        className={
                                                            ScheduleClasses[
                                                            "completed"
                                                            ]
                                                        }>
                                                        Completed
                                                    </span>
                                                ) : (
                                                    <span
                                                        className={
                                                            ScheduleClasses[
                                                            "cancelled"
                                                            ]
                                                        }>
                                                        Cancelled By{" "}
                                                        {{
                                                            1: "Admin",
                                                            2: "Relation Manager",
                                                            3: "Tutor",
                                                            4: "Parent",
                                                            5: "Sales Manager",
                                                            6: "Senior RM",
                                                            7: "Senior SM",
                                                            8: "Project Manager",
                                                            9: "HR Manager",
                                                            10: "MIS",
                                                            11: "Finance",
                                                            14: "Quality Checker",
                                                            15: "Sales Coordinator"
                                                        }[item.CancelledByType] || "Unknown"}
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td
                                        colSpan={9}
                                        style={{ textAlign: "center" }}>
                                        No Record Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
            {/* <TableLoad /> */}
        </>
    );
};

export default Classes;
